import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import Notifications from 'vue-notification'
import loginView from '@/components/View_Login'
import registroView from '@/components/View_Registrar'

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(Notifications)
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'registrar',
      component: registroView
    },
    {
      path: '/ingresar',
      name: 'login',
      component: loginView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/not_logged.js